export const Message = ({ ...props }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 0.5H3C1.625 0.5 0.5 1.625 0.5 3V25.5L5.5 20.5H23C24.375 20.5 25.5 19.375 25.5 18V3C25.5 1.625 24.375 0.5 23 0.5ZM9.25 11.75H6.75V9.25H9.25V11.75ZM14.25 11.75H11.75V9.25H14.25V11.75ZM19.25 11.75H16.75V9.25H19.25V11.75Z"
        fill="#EF4F34"
      />
    </svg>
  );
};
